import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface BrandProps {
  className?: string;
  to?: string;
  /** Hide the wordmark, show the tile only. */
  iconOnly?: boolean;
}

export function Brand({ className, to = "/", iconOnly = false }: BrandProps) {
  return (
    <Link
      to={to}
      className={cn(
        "flex items-center gap-2 font-semibold tracking-tight transition-opacity hover:opacity-80",
        className,
      )}
      aria-label="MemKernel — home"
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-foreground text-[11px] font-bold text-background">
        mk
      </span>
      {!iconOnly && <span>MemKernel</span>}
    </Link>
  );
}
